import React from 'react'
import TextField from 'material-ui/TextField';

export default class FieldComponent extends React.Component {
  up (e) {
    if (this.props.onChange) this.props.onChange(this.props.type === 'checkbox' ? e.target.checked : e.target.value)
  }

  component () {
    const {value, type, gotError} = this.props

    const style = this.props.style || {}
    const className = (this.props.className || '' ) + (gotError ? ' has-error' : '')
    const inputStyle = this.props.inputStyle || {}
    switch (type) {
      case 'number':
      case 'text': {
        return (<TextField type={type} className={className}
                   name={this.props.name}
                   style={style}
                   value={value}
                   inputStyle={inputStyle}
                   onChange={e => this.up(e)}
                   required={this.props.required}
                   readOnly={this.props.disabled}
                   onBlur={this.props.onBlur || null}
                   placeholder={this.props.placeholder}
                />)
      }
      case 'textarea': {
        return (<textarea className={className}
                   style={style}
                    value={value}
                    onChange={e => this.up(e)}
                    onBlur={this.props.onBlur || null}
                    required={this.props.required}
                    readOnly={this.props.disabled}
                    placeholder={this.props.placeholder}
                  />)
      }
      case 'checkbox': {
        return (<input type="checkbox"
                 className={className}
                 style={style}
                 value={!!value}
                 checked={!!value}
                 onChange={e => this.up(e)}
                 required={this.props.required}
                 readOnly={this.props.disabled}
               />)
      }
      default: {
        return (<TextField type="text" className={className}
                 name={this.props.name}
                 style={style}
                 value={value}
                 inputStyle={inputStyle}
                 onChange={e => this.up(e)}
                 required={this.props.required}
                 readOnly={this.props.disabled}
                 onBlur={this.props.onBlur || null}
                 placeholder={this.props.placeholder}
               />)
      }
    }
  }

  render () {
    return this.component()
  }
}



// WEBPACK FOOTER //
// ./src/shared/inputs/components/FieldComponent.jsx